import { DocSearch, version, } from '@docsearch/react';
import React from 'react';
import ReactDOM from 'react-dom';
import '@docsearch/css';
function getHTMLElement(value, environment = window) {
    if (typeof value === 'string') {
        return environment.document.querySelector(value);
    }
    return value;
}
function Footer({ state }) {
    return React.createElement(React.Fragment, null,
        React.createElement("footer", null,
            React.createElement("a", { href: "/doc/search?v=" + _docsearch_version + "&q=" + state.query },
                "Show all ",
                state.context.nbHits,
                " results")));
}
function Hit({ hit }) {
    let myHit = hit;
    let path = hit.hierarchy.lvl1;
    if (hit.hierarchy.lvl2) {
        path += myHit.isModule ? ':' : ' → ';
        path += hit.hierarchy.lvl2;
    }
    return React.createElement("a", { href: hit.url },
        React.createElement("div", { className: "DocSearch-Hit-Container" },
            React.createElement("div", { className: "DocSearch-Hit-icon" },
                React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20" },
                    React.createElement("path", { d: "M17 5H3h14zm0 5H3h14zm0 5H3h14z", stroke: "currentColor", fill: "none", "fill-rule": "evenodd", "stroke-linejoin": "round" }))),
            React.createElement("div", { className: "DocSearch-Hit-content-wrapper" },
                React.createElement("span", { className: "DocSearch-Hit-title" }, hit.content),
                React.createElement("span", { className: "DocSearch-Hit-path" }, path)),
            React.createElement("div", { className: "DocSearch-Hit-action" },
                React.createElement("svg", { className: "DocSearch-Hit-Select-Icon", width: "20", height: "20", viewBox: "0 0 20 20" },
                    React.createElement("g", { stroke: "currentColor", fill: "none", "fill-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" },
                        React.createElement("path", { d: "M18 3v4c0 2-2 4-4 4H2" }),
                        React.createElement("path", { d: "M8 17l-6-6 6-6" }))))));
}
const docsearch = React.createElement(DocSearch, { appId: 'LUYTU1J2MB', indexName: 'erlang', apiKey: "86152ba1d4a9d7e179d537b8060a4c31", searchParameters: {
        filters: 'version:' + _docsearch_version,
        attributesToRetrieve: [
            'hierarchy.lvl0',
            'hierarchy.lvl1',
            'hierarchy.lvl2',
            'hierarchy.lvl3',
            'hierarchy.lvl4',
            'hierarchy.lvl5',
            'hierarchy.lvl6',
            'content',
            'type',
            'url',
            'isModule'
        ]
    }, resultsFooterComponent: Footer, hitComponent: Hit, transformSearchClient: (searchClient) => {
        searchClient.addAlgoliaAgent('docsearch.js', version);
        return searchClient;
    } });
const button = getHTMLElement('#docsearch');
ReactDOM.render(docsearch, button);
const mobile = getHTMLElement('#docsearch-mobile');
if (mobile) {
    mobile.addEventListener('click', () => {
        button.getElementsByTagName('button')[0].click();
    });
}
